var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "error-modal-container",
      style: _vm.errorModalPos,
      on: {
        mouseenter: function ($event) {
          return _vm.toggleErrorShow(true)
        },
        mouseleave: function ($event) {
          return _vm.toggleErrorShow(false)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "error-label",
          class: { "no-error": !_vm.errorModalData.count },
        },
        [
          _vm._v(
            " " +
              _vm._s(
                _vm.$tc("smartSearch.errorsTipNum", _vm.errorModalData.count, {
                  num: _vm.errorModalData.count,
                })
              ) +
              " "
          ),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.errorModalData.htmlStr && _vm.showErrorContent,
              expression: "errorModalData.htmlStr&&showErrorContent",
            },
          ],
          staticClass: "error-conent__container",
        },
        [
          _c("div", {
            class: [_vm.CLASS_NAME_ERROR_CONTENT],
            domProps: { innerHTML: _vm._s(_vm.errorModalData.htmlStr) },
          }),
        ]
      ),
      _vm.tipData
        ? _c("error-tip", {
            attrs: { "tip-data": _vm.tipData },
            nativeOn: {
              mouseenter: function ($event) {
                return _vm.clearSymbolTip(false)
              },
              mouseleave: function ($event) {
                return _vm.clearSymbolTip(true)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }